import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';

// props:
// - visible
// - serviceType
// - onHide
// - onServiceTypeSaved
function ServiceTypeEditDialog(props) {

  // #region Vars and Consts

  const [isNew, setIsNew] = useState(false);  
  const [active, setActive] = useState(true);
  const defaultValues = {
    description: ""    
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });

  // #endregion

  // #region Methods

  const resetForm = () => {
    reset(defaultValues);
    setActive(true);
  }

  const createServiceType = (    
    description,    
    active) => {
    console.group("Create service type");
    fetch(`${process.env.REACT_APP_API_URL}/serviceType/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({     
        description,        
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Service type created");
        props.onServiceTypeSaved();
        reset();
      } else {
        console.warn("Error creating service type");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error creating service type", error);
      console.groupEnd();
    });
  };

  const updateServiceType = (
    serviceTypeId,    
    description,    
    active) => {
    console.group("Updating service type");
    fetch(`${process.env.REACT_APP_API_URL}/serviceType/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serviceTypeId,        
        description,        
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Service type updated");
        props.onServiceTypeSaved();
        reset();
      } else {
        console.warn("Error updating service type");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error updating service type", error);
      console.groupEnd();
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  // #endregion

  // #region Events

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };

  const onFormSubmit = (data) => {
    if (isNew) {
      createServiceType(
        data.description,       
        active
      );
    } else {
      updateServiceType(
        props.serviceType.serviceTypeId,
        data.description,        
        active);
    }
  };

  useEffect(() => {
    resetForm();
    if (props.serviceType) {
      setIsNew(false);
      reset(props.serviceType);
      setActive(props.serviceType.active);
    } else {
      setIsNew(true);
    }
  }, [props.visible, props.serviceType]);

  // #endregion

  // #region Templates

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid">
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="description"
              className={classNames({ 'p-error': errors.description })}>
              Descripción
            </label>
            <Controller
              name="description"
              control={control}
              rules={{ required: 'La descripción es requeridaa.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  maxLength={255}
                  autoFocus
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
              )} />
            {getFormErrorMessage('description')}
          </Col>
        </Row>
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="active">
              Activo
            </label>
            <br></br>
            <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
          </Col>
        </Row>
        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4" />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Tipo de Servicio</h1>
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default ServiceTypeEditDialog;